<template>
  <component :is="type + 'Add'" v-if="type" ref="addDeviceModal" />
</template>
<script>
import PowerAdd from './power/Add'

export default {
  components: {
    PowerAdd,
  },
  data() {
    return {
      loading: false,
      type: null,
      edit: false,
      id: null,
    }
  },
  methods: {
    saveDevice(e) {
      e.preventDefault()
      this.$refs.addDeviceModal.$validator.validateAll().then(() => {
        if (
          !this.$refs.addDeviceModal.errors.any() &&
          !this.$refs.addDeviceModal.loading
        ) {
          if (this.edit) {
            this.$api
              .post('energetics/edit_device', this.$refs.addDeviceModal.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('modal-hide', 'add-device')
                this.$root.$emit('reloadEnergeticDeviceData')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri aktualizovaní hodnôt',
                  timer: 5000,
                })
              })
          } else {
            this.$api
              .post('energetics/add_device', this.$refs.addDeviceModal.form)
              .then((res) => {
                this.$swal({
                  type: 'success',
                  position: 'top',
                  showCloseButton: true,
                  text: res.data.message,
                  timer: 5000,
                })
                this.$root.$emit('reloadEnergeticDeviceData')
                this.$root.$emit('modal-hide', 'add-device')
              })
              .catch(() => {
                this.$swal({
                  type: 'error',
                  position: 'top',
                  showCloseButton: true,
                  text: 'Vyskytla sa chyba pri pridávaní hodnôt',
                  timer: 5000,
                })
              })
          }
        } else {
          this.$swal({
            type: 'warning',
            position: 'top',
            showCloseButton: true,
            text: 'Formulár nieje správne vyplnený',
            timer: 5000,
          })
        }
      })
    },
  },
}
</script>
